// src/index.js
import React from "react";
import ReactDOM from "react-dom/client";
import MainRouter from "./router/MainRouter"; // Import the MainRouter
import "./styles/App.scss"; // Global styles

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <MainRouter />
  </React.StrictMode>
);
